var path = 'directives/navTabs/navTabs.html';
var html = "<li ng-class=\"{ active: !tabs.activeTab }\" rel=tab1><a href=\"\" id=table ui-sref=\"datacenter.main({ activeTab: undefined, startTimeframe: undefined })\">Table</a></li><li ng-class=\"{ active: tabs.activeTab === 'map' }\" ng-hide=\"tabs.rules.Map === false || tabs.rules.medicare\" rel=tab2><a href=\"\" id=map ui-sref=\"datacenter.main({ activeTab: 'map', startTimeframe: undefined })\">Map</a></li><li ng-class=\"{ active: tabs.activeTab === 'graph' }\" ng-hide=\"tabs.rules.Graph === false  || tabs.rules.medicare\" rel=tab3><a href=\"\" id=graph ui-sref=\"datacenter.main({ activeTab: 'graph' })\">Trend Graph</a></li>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./js/directives/navTabs/navTabs.html
// module id = 182
// module chunks = 0